import styled from 'styled-components';
import { respondTo } from '../../common/styles/mixins';
import * as colors from '../../common/styles/colors';

export const AdminDocumentRepositoryWrapper = styled.div`
  .adminDocumentRepository {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .displayCenter {
    display: flex;
    margin: 0 auto;
  }
`;

export const AdminDocumentRepositoryModalWrapper = styled.div`
  .modal-title {
    color: ${colors.hydroBlue};
  }

  .rmdp-input {
    height: 40px;
  }

  .datePicker {
    width: 20%;
  }

  .documentType {
    width: 50%;
  }

  .recipientPicker {
    width: 30%;
  }

  .referenceBox {
  width: 65%;
  }

  .dropzonecontainer {
    border 2px ${colors.hydroBlue} dashed;
    border-radius: 10px;
    height: 150px;

    div {
      color: ${colors.hydroBlue};
    }

    .loaIcon {
      display: none;
      left: 2px;

      ${respondTo.tablet`
        display: block;
        left: 2px;
      `}

      ${respondTo.desktop`
        display: block;
        left: 50px;
        padding-left: 30px;
      `}
    }

    .title {
      font-size: 20px;
    }
  }

  .filecontainer {
    .file {
      border 2px ${colors.midGrey} solid;
      border-radius: 10px;
      color: ${colors.darkGrey};
    }
  
    .filepath {
      white-space: nowrap;
      padding-right: 30px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .filesize {
      line-height: 0.8;
      padding-bottom: 5px;
    }

    .delete {
      cursor: pointer;
    }

    .close {
      margin-top: -7px;
      padding-right: 10px;
    }

    .closeUpdate {
      margin-top: -16px;
      padding: 0;
      background-color: transparent;
      border: 0;
      position: absolute;
      right: 20px;
      top: 15px;
      font-size: 1.5rem;
      line-height: 1;
    }
  }

  .errors {
    color: ${colors.danger};
    padding-top: 10px;
  }

  .upload-btn {
    border-radius: 16px;
  }
`;

export const AdminDocumentRepositoryGridWrapper = styled.div``;
